export default {
  namespaced: true,
  state: {
    brandFilterValue: "",
  },
  getters: {
    brandFilter: state => state.brandFilterValue,
  },
  actions: {
    setBrandFilterValue: (context, data) => context.commit("setBrandFilterValue", data),
  },
  mutations: {
    setBrandFilterValue: (state, value) => {
      state.brandFilterValue = value;
    },
  },
};
